module.exports = __webpack_public_path__ + "static/media/minnesota-timberwolves.6b3fb6c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/minnesota-timberwolves.svg
// module id = 235
// module chunks = 0